import { localize } from "@/locale/i18n"

let idx = 10;

const appRoutes = {
    routes: null,
    /**
     * @param {string[]} userPerms
     */
    init: function (routes, userPerms) {
        if (this.routes) return;
        this.routes = []
        outerLoop:
        for (let i = 0; i < routes.length; i++) {
            let r = routes[i]
            if (r.perms && r.perms.length != 0) {
                for (let j = 0; j < r.perms.length; j++) {
                    if (!userPerms.includes(r.perms[j])) {
                        continue outerLoop;
                    }
                }
            }
            r.id = idx++
            this.routes.push(r)
        }
    },

    /**
     * @param string
     */
    getRoute: function (name) {
        if (!this.routes) return null;
        for (let i = 0; i < this.routes.length; i++) {
            if (this.routes[i].name == name) {
                return this.routes[i]
            }
        }
        return null;
    },

    /**
     * @param string
     */
    getCatRoutes: function (cat) {
        if (!this.routes) return null;
        const res = []
        for (let i = 0; i < this.routes.length; i++) {
            if (this.routes[i].cat == cat) {
                res.push(this.routes[i])
            }
        }
        return res;
    },

    setActiveRoute: function (path) {
        path = path.endsWith('/') ? path.slice(0, -1) : path
        for (let i = 0; i < this.routes.length; i++) {
            if (this.routes[i].path == path) {
                this.routes[i].active = true
            }
        }
    },

    regRoutes: function (router) {
        if (this.routes.length === 0) {
            return;
        }

        this.routes.forEach(r => {
            if (r.view == "forbidden") {
                r.path = "/forbidden?perms-required=" + r.perms.join(",");
            }

            router.addRoute({
                path: r.path,
                name: r.name,
                meta: {
                    layout: "Main",
                    auth: true,
                },
                component: () => import(`@/${r.view}.vue`)
            });
        });

        // set window title by route name
        router.afterEach((to) => {
            let route = this.routes.find(r => r.path === to.path);
            if (route && route.name) {
                document.title = localize(route.name) + ' | Cabinet 2.1';
            }
        });
    },
}


export default appRoutes;